import {FC} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  visible: boolean
  title: string
  subtitle?: string
  confirmLabel: string
  confirmClassName?: string
  onClose: () => void
  onConfirm: () => void
}

const MainEngineActionConfirmModal: FC<Props> = ({
  visible,
  title,
  subtitle,
  confirmLabel,
  confirmClassName = 'btn btn_primary',
  onClose,
  onConfirm,
}) => {
  if (!visible) return null

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={(e) => e.stopPropagation()} style={{maxWidth: '520px'}}>
        <div className='d-flex justify-content-end align-items-center'>
          <button className='close-btn' onClick={onClose}>
            <KTSVG path='/media/map/x.svg' className='svg-icon-2x' />
          </button>
        </div>
        <div className='custom-modal-body'>
          <div className='d-flex justify-content-center mb-4'>
            <KTSVG path='/media/map/exclamation.svg' className='svg-icon-4x' />
          </div>
          <p className='text-center mb-1'>{title}</p>
          {subtitle ? <p className='text-center text-muted fs-7'>{subtitle}</p> : null}

          <div className='d-flex justify-content-center gap-2 mt-5'>
            <button type='button' className='btn btn_secondary' onClick={onClose}>No, Cancel</button>
            <button type='button' className={confirmClassName} onClick={onConfirm}>{confirmLabel}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainEngineActionConfirmModal
